import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Table } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import "../styles/AiotaMembersList.css";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Sample data for members (replace with actual data if needed)
const sampleMembers = [
  {
    _id: "1",
    name: "Whoopi Hubbard",
    licenseNo: "AIOTA001",
  },
  {
    _id: "2",
    name: "Jamal Bishop",
    licenseNo: "AIOTA002",
  },
  {
    _id: "3",
    name: "John Smith",
    licenseNo: "AIOTA003",
  },
  {
    _id: "4",
    name: "John Smith",
    licenseNo: "AIOTA003",
  },
  {
    _id: "5",
    name: "John Smith",
    licenseNo: "AIOTA003",
  },
  {
    _id: "6",
    name: "John Smith",
    licenseNo: "AIOTA003",
  },
  {
    _id: "7",
    name: "John Smith",
    licenseNo: "AIOTA003",
  },
  {
    _id: "8",
    name: "John Smith",
    licenseNo: "AIOTA003",
  },
  {
    _id: "9",
    name: "John Smith",
    licenseNo: "AIOTA003",
  },
  {
    _id: "10",
    name: "John Smith",
    licenseNo: "AIOTA003",
  },
  {
    _id: "11",
    name: "John Smith",
    licenseNo: "AIOTA003",
  },
];

const AiotaMembersList = () => {
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const [data, setData] = useState(sampleMembers);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState) {
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  // Mock pagination logic (since no backend)
  useEffect(() => {
    // Filter data based on search
    const filteredData = sampleMembers.filter(
      (item) =>
        item.name.toLowerCase().includes(search.toLowerCase()) ||
        item.licenseNo.toLowerCase().includes(search.toLowerCase())
    );

    // Calculate total pages based on limit
    setData(filteredData);
    setTotalPages(Math.ceil(filteredData.length / limit));

    // Reset to first page if current page exceeds total pages
    if (currentPage > Math.ceil(filteredData.length / limit)) {
      setCurrentPage(1);
    }
  }, [search, limit, currentPage]);

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(parseInt(e.target.value));
    setCurrentPage(1); // Reset to first page when limit changes
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1); // Reset to first page when search changes
  };

  // Format date to DD MMMM YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      })
      .toUpperCase();
  };

  // Paginate data
  const paginatedData = data.slice(
    (currentPage - 1) * limit,
    currentPage * limit
  );

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">
              All India Occupational Therapists' Association
            </h1>
            {!tokenState && (
              <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="members-table-section">
            <Container>
              <h2 className="members-table-heading">Membership List</h2>

              <div className="members-table-controls d-flex justify-content-between align-items-center flex-column flex-sm-row">
                <div className="members-table-entries-control align-items-center align-items-sm-start align-items-md-center">
                  <span className="members-table-entries-text">Show</span>
                  <Form.Select
                    className="members-table-entries-select"
                    value={limit}
                    onChange={handleLimitChange}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </Form.Select>
                  <span className="members-table-entries-text">entries</span>
                </div>
                <div className="members-table-search-control">
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    className="members-table-search-input"
                    value={search}
                    onChange={handleSearchChange}
                  />
                </div>
              </div>

              <div className="table-responsive">
                <Table bordered responsive className="members-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>License Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length > 0 ? (
                      paginatedData.map((item) => (
                        <tr key={item._id}>
                          <td>{item.name || "N/A"}</td>
                          <td>{item.licenseNo || "N/A"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>

              <Row className="members-table-controls mt-1 m-0">
                <Col xs={12} sm={6} className="d-flex align-items-center">
                  <span className="d-none d-sm-block">
                    Showing {(currentPage - 1) * limit + 1} to{" "}
                    {Math.min(currentPage * limit, data.length)} of{" "}
                    {data.length} entries
                  </span>
                </Col>
                <Col xs={12} sm={6} className="d-flex justify-content-md-end justify-content-center">
                  <div className="members-table-pagination d-flex gap-2">

                    {/* Previous Button */}
                    <Button
                      variant="outline-light"
                      size="sm"
                      className="members-table-pagination-btn"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                        {/* Small screen: Show Icon */}
                        <span className="d-md-none"><ChevronLeft/></span>
                        <span className="d-none d-md-block">Prevous</span>
                    </Button>

                    {/* Current Page */}
                    <Button
                    variant="primary"
                    size="sm"
                    className="members-table-pagination-btn members-table-pagination-active"
                    >
                    {currentPage}
                    </Button>

                      {/* Next Button */}
                    <Button
                      variant="outline-light"
                      size="sm"
                      className="members-table-pagination-btn"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                        {/* Small screen: Show Icon */}
                        <span className="d-md-none"><ChevronRight/></span>
                        <span className="d-none d-md-block">Prevous</span>
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default AiotaMembersList;
